import { createClient } from "@sanity/client";

import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
  projectId: "r2177h3c",
  dataset: "production",
  apiVersion: "2025-04-19",
  useCdn: false,
});

export async function getProviders() {
  const providers = await client.fetch('*[_type == "provider"]');
  providers.sort((a, b) => a.teamPageOrder - b.teamPageOrder);
  return providers
    .filter((provider) => !provider.excludeFromWebsite)
    .map((provider) => {
      provider.officePictureUrl = imageUrlBuilder(client)
        .image(provider.officePicture)
        .url();
      provider.profilePictureUrl = imageUrlBuilder(client)
        .image(provider.profilePicture)
        .url();
      return provider;
    });
}

export async function getHomePage() {
  const homePage = await client.fetch('*[_type == "homePage"]');
  return homePage[0];
}

export async function getFaqsPage() {
  const faqsPage = await client.fetch('*[_type == "faqsPage"]');
  faqsPage[0].imageUrl = imageUrlBuilder(client).image(faqsPage[0].Image).url();
  return faqsPage[0];
}

export async function getTeamPage() {
  const teamPage = await client.fetch('*[_type == "teamPage"]');
  teamPage[0].groupPictureUrl = imageUrlBuilder(client)
    .image(teamPage[0].groupPicture)
    .url();
  return teamPage[0];
}

export async function getCommunityPage() {
  const communityPage = await client.fetch('*[_type == "communityPage"]');
  return communityPage[0];
}

export async function getResourcesPage() {
  const resourcesPage = await client.fetch('*[_type == "resourcesPage"]');
  return resourcesPage[0];
}

export async function getContactPage() {
  const contactPage = await client.fetch('*[_type == "contactPage"]');
  contactPage[0].largeImageUrl = imageUrlBuilder(client)
    .image(contactPage[0].LargeImage)
    .url();
  contactPage[0].smallImageLeftUrl = imageUrlBuilder(client)
    .image(contactPage[0].SmallImageLeft)
    .url();
  contactPage[0].smallImageRightUrl = imageUrlBuilder(client)
    .image(contactPage[0].SmallImageRight)
    .url();
  return contactPage[0];
}

export async function getCommunityEvents() {
  const communityEvents = await client.fetch('*[_type == "communityEvent"]');
  return communityEvents.map((communityEvent) => {
    console.debug("communityEvent", communityEvent.Image);
    if (communityEvent.Image) {
      communityEvent.eventImageUrl = imageUrlBuilder(client)
        .image(communityEvent.Image)
        .url();
    } else {
      communityEvent.eventImageUrl = null;
    }
    return communityEvent;
  });
}
